import { useCallback } from 'react';

export const useMainFocusTrapControl = () => {
    const disableMainFocusTrap = useCallback(() => {
        window.dispatchEvent(new CustomEvent('main-focus-trap-disable'));
    }, []);

    const enableMainFocusTrap = useCallback(() => {
        window.dispatchEvent(new CustomEvent('main-focus-trap-enable'));
    }, []);

    return {
        disableMainFocusTrap,
        enableMainFocusTrap,
    };
};
